import { createAsyncThunk } from "@reduxjs/toolkit"

export const getPVZ = createAsyncThunk("/getPVZ", async (data, thunkAPI) => {
	try {
		return data
	} catch (error) {
		return thunkAPI.rejectWithValue("Error")
	}
})
